/*
 *     Copyright (c) 2020 Bcame S.r.l.. All rights reserved.
 *     Bcame S.r.l. Technology Business Unit
 *
 *     Company confidential.
 *
 *     This software is proprietary  to and embodies the confidential
 *     technology of Bcame S.r.l..  Possession, use, or copying of this
 *     software and media is authorized only pursuant to a valid written
 *     license from Bcame S.r.l.  or an authorized sublicensor.
 *
 *     Bcame S.r.l.
 */

<template>
  <div class="cart-recap cart-recap_summary">
    <div class="cart-item">
      <SummaryPrice/>
      <div class="custom-message mcart-message">
        <p>{{ $t('shipment-cart-message') }}</p>
      </div>
      <div class="cart-recap__checkout">
        <div class="cart-recap__checkout__cta-payment">
          <div class="cta">
            <router-link :to="{ name: 'cart' }" class="btn btn-primary w-100" v-if="showCartBtn">{{ $t('view-cart') }}</router-link>
            <router-link :to="{name: 'onepagecheckout'}" class="btn btn-primary w-100" v-if="showCheckoutBtn">{{ $t('proceed-to-checkout') }}</router-link>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import SummaryPrice from './SummaryPrice'

export default {
  props: {
    showCheckoutBtn: {
      type: Boolean,
      required: false,
      default: true
    },
    showPaymentBtn: {
      type: Boolean,
      required: false,
      default: true
    },
    showCartBtn: {
      type: Boolean,
      required: false,
      default: false
    }
  },
  components: {
    SummaryPrice
  }
}
</script>
